import React from "react";

import { managedCompanyProfileIdParam } from "Dashboard/EmployerUrls";
import { getAccount, getAccountCompanyProfileById } from "EntitiesApi/api";
import { Provider } from "react-redux";
import PartnerProvider from "Common/PartnerProvider";
import companyToken from "Utils/companyToken";

import { receiveEmployerData } from "./actions";
import EmployerDashboard from "./EmployerDashboard";
import createStore from "./store";

import type { State, Action } from "./store";
import type { Match } from "react-router-dom";
import type { Store } from "redux";

type Props = {
  match: Match;
};

class App extends React.Component<Props> {
  store: Store<State, Action>;

  match: Match;

  constructor(props: Props) {
    super(props);
    this.match = props.match;
    this.store = createStore({
      accountId: "",
    });
  }

  componentDidMount() {
    // No error handling on failure to fetch
    const managedCompanyProfileId = this.match.params[managedCompanyProfileIdParam];

    const flags = ["enrolledCompanyPolicy", "enrolledEmployeePolicy", "upcomingCompanyPolicy", "cancelledCompanyPolicy", "companyContributions"];

    const companyIDToken = companyToken();
    if (companyIDToken) {
      this.store.dispatch(
        getAccountCompanyProfileById(companyIDToken, {
          include: flags,
          onSuccess: (response, dispatch, _request) => {
            dispatch(receiveEmployerData(response));
          },
        }),
      );
    } else {
      if (managedCompanyProfileId) {
        flags.push(managedCompanyProfileId);
      }
      this.store.dispatch(
        getAccount({
          include: flags,
          onSuccess: (response, dispatch, _request) => {
            dispatch(receiveEmployerData(response));
          },
        }),
      );
    }
  }

  render() {
    return (
      <Provider store={this.store}>
        <PartnerProvider>
          <EmployerDashboard />
        </PartnerProvider>
      </Provider>
    );
  }
}

export default App;
